import React from 'react';

function ControlPoint({ label, data, setData }) {

    const handleFiles = (type, files) => {
        const fileArray = Array.from(files);
        setData({ ...data, [type]: [...data[type], ...fileArray] });
    };

    return (
        <div style={{ border: '1px solid #ccc', padding: '10px', marginBottom: '20px' }}>
            <h4>{label}</h4>
            <div>
                <label>Photos Avant :</label>
                <input type="file" accept="image/*" multiple onChange={e => handleFiles('before', e.target.files)} />
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '5px' }}>
                    {data.before.map((file, i) => (
                        <img key={i} src={URL.createObjectURL(file)} alt="avant" width="80" height="80" style={{ objectFit: 'cover', borderRadius: '5px' }} />
                    ))}
                </div>
            </div>
            <div>
                <label>Photos Après :</label>
                <input type="file" accept="image/*" multiple onChange={e => handleFiles('after', e.target.files)} />
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '5px' }}>
                    {data.after.map((file, i) => (
                        <img key={i} src={URL.createObjectURL(file)} alt="apres" width="80" height="80" style={{ objectFit: 'cover', borderRadius: '5px' }} />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ControlPoint;